import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconStop(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15 9H9v6h6V9ZM9 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M12 22.001a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175a9.733 9.733 0 0 1-.788-3.9c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138a9.743 9.743 0 0 1 3.9-.787c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175a9.733 9.733 0 0 1 .788 3.9 9.733 9.733 0 0 1-.788 3.9 10.093 10.093 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137a9.733 9.733 0 0 1-3.9.788Zm0-2c2.217 0 4.104-.779 5.663-2.337C19.221 16.105 20 14.218 20 12.001s-.779-4.104-2.337-5.663C16.104 4.78 14.217 4.001 12 4.001s-4.104.779-5.662 2.337C4.779 7.897 4 9.784 4 12.001s.78 4.104 2.338 5.663c1.558 1.558 3.445 2.337 5.662 2.337Z"
      />
    </BaseIcon>
  );
}
